import PropTypes from 'prop-types';

import Panel from '#globalComponents/Overlay/Panel';
import Popover from '#globalComponents/Overlay/Popover';

import CallReachedConfirm from './CallReachedConfirm';

const CallReachedPopover = ({ anchorRef, onSelect, onCancel }) => (
	<Popover open onClose={onCancel} anchorRef={anchorRef} size="s">
		<Panel.Body className="px-3.5 py-2.5">
			<p className="text-xs text-bgBase-800 font-medium mb-2">Wurde der Kontakt erreicht?</p>
			<CallReachedConfirm onSelect={onSelect} onCancel={onCancel} />
		</Panel.Body>
	</Popover>
);

CallReachedPopover.propTypes = {
	anchorRef: PropTypes.shape({ current: PropTypes.any }),
	onSelect: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

export default CallReachedPopover;
